import { UseFormReturn } from 'react-hook-form';
import { NotificationInstance } from '@src/components/ui/notification';

export type WebComponentServerValidationError = {
    name: string;
    message: string;
};

export const getServerValidationErrorName = (
    error: WebComponentServerValidationError,
) => error.name;

export const getServerValidationErrorMessage = (
    error: WebComponentServerValidationError,
) => error.message;

export const applyServerValidationErrors = ({
    errors,
    form,
    getFieldLabel,
    notification,
    t,
}: {
    errors: WebComponentServerValidationError[];
    form?: UseFormReturn;
    getFieldLabel: (fieldId: string) => string | undefined;
    notification: NotificationInstance;
    t: (key: string) => string;
}) => {
    if (!form || errors.length === 0) return [];

    const appliedFieldNames: string[] = [];

    errors.forEach((error) => {
        const fieldName = getServerValidationErrorName(error);
        const message =
            getServerValidationErrorMessage(error) ||
            t('translation:pleaseFillAllRequiredFields');

        appliedFieldNames.push(fieldName);
        form.setError(fieldName, {
            type: 'manual',
            message,
        });
    });

    const firstError = errors[0];
    const firstFieldName = firstError
        ? getServerValidationErrorName(firstError)
        : '';
    const firstFieldLabel = firstFieldName
        ? getFieldLabel(firstFieldName)
        : undefined;
    const firstMessage = firstError
        ? getServerValidationErrorMessage(firstError)
        : '';

    if (firstFieldName) {
        form.setFocus(firstFieldName);
    }

    notification.error({
        message: t('translation:validationRequired'),
        description:
            firstFieldLabel && firstMessage
                ? `${firstFieldLabel}: ${firstMessage}`
                : firstMessage ||
                  firstFieldLabel ||
                  t('translation:pleaseFillAllRequiredFields'),
    });

    return appliedFieldNames;
};
